import { BrowserModule } from "@angular/platform-browser"
import { NgModule } from "@angular/core"
import { HttpClientModule } from "@angular/common/http"
import { FormsModule } from "@angular/forms"
import { InlineSVGModule } from "ng-inline-svg"
import { NgxPaginationModule } from "ngx-pagination"

import { AppComponent } from "./app.component"
import { FilmCardsComponent } from "./film-cards/film-cards.component"
import { FilmSearchComponent } from "./film-search/film-search.component"

import { SearchCountriesPipe } from "./search-countries.pipe"
import { SearchFormatsPipe } from "./search-formats.pipe"
import { SearchGenresPipe } from "./search-genres.pipe"
import { SearchInterestsPipe } from "./search-interests.pipe"
import { SearchThemesPipe } from "./search-themes.pipe"
import { SearchLanguagesPipe } from "./search-languages.pipe"
import { SearchFilmsPipe } from "./search-films.pipe"
import { SearchFestivalsPipe } from "./search-festivals.pipe"
import { SearchYearsPipe } from "./search-years.pipe"
import { SearchViewingPipe } from "./search-viewing.pipe"
import { SearchGradesPipe } from "./search-grades.pipe"
import { OrderByPipe } from "./order-by.pipe"

@NgModule({
  declarations: [
    AppComponent,
    FilmCardsComponent,
    FilmSearchComponent,
    SearchFilmsPipe,
    SearchCountriesPipe,
    SearchFormatsPipe,
    SearchGenresPipe,
    SearchInterestsPipe,
    SearchThemesPipe,
    SearchLanguagesPipe,
    SearchFestivalsPipe,
    SearchYearsPipe,
    SearchViewingPipe,
    SearchGradesPipe,
    OrderByPipe,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    InlineSVGModule.forRoot(),
    NgxPaginationModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
